import { Box, Grid, Typography } from '@mui/material'
import { Form } from 'components/form'
import { useAlert } from 'contexts/alert'
import React, { Fragment } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useStyles } from './styles'

interface IColorConfigProps {
  formData: UseFormReturn<any>
}

const ColorConfig: React.FC<IColorConfigProps> = ({
  formData: {
    watch,
    control,
    register,
    formState: { errors },
  },
}) => {
  const { closeAlert } = useAlert()
  const classes = useStyles()

  const handleChange = (formField: any) => closeAlert()

  return (
    <>
      <Typography variant='h6'>
        Agora preencha os campos com as cores primaria, secundaria e terciária no formato hexadecimal
        (#FFFFFF)
      </Typography>

      <Box className={classes.formBox}>
        <Form.Input
          fullWidth
          type='color'
          label='Cor Primaria'
          error={!!errors.primaryColor}
          errorMessage={errors?.primaryColor?.message as string}
          disabled={false}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={255}
          name='primaryColor'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
          control={control}
        />

        <Form.Input
          fullWidth
          type='color'
          label='Cor Segundaria'
          error={!!errors.secondaryColor}
          errorMessage={errors?.secondaryColor?.message as string}
          disabled={false}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={255}
          name='secondaryColor'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
          control={control}
        />

        <Form.Input
          fullWidth
          type='color'
          label='Cor Terciária'
          error={!!errors.terciaryColor}
          errorMessage={errors?.terciaryColor?.message as string}
          disabled={false}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={255}
          name='terciaryColor'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
          control={control}
        />
      </Box>

      <Grid
        container
        className={classes.itemBox}
      >
        <Grid
          item
          xs={4}
        >
          <Box
            className={classes.colorBox}
            bgcolor={`#${watch('primaryColor')}`}
          />
          <span>Primaria</span>
        </Grid>
        <Grid
          item
          xs={4}
        >
          <Box
            className={classes.colorBox}
            bgcolor={`#${watch('secondaryColor')}`}
          />
          <span>Secundaria</span>
        </Grid>
        <Grid
          item
          xs={4}
        >
          <Box
            className={classes.colorBox}
            bgcolor={`#${watch('terciaryColor')}`}
          />
          <span>Terciária</span>
        </Grid>
      </Grid>
    </>
  )
}

export default ColorConfig
